import { AdditionalHeating } from '~domain/model/application/allset-data.type';
import { Province } from '~domain/model/core/address/province';
import { Carrier } from '~domain/model/core/carrier';
import { HomeLine } from '~domain/model/core/home-line';
import { ProductType } from '~domain/model/core/product-type';

// ========== Home flow variables ==========
// Number of years heating renovation question must be asked
export const HEATING_RENOVATION_THRESHOLD: Map<Province, number> = new Map([
  [Province.Quebec, 30],
  [Province.Ontario, 25],
]);

// Number of years roof replacement question must be asked
export const ROOF_REPLACEMENT_THRESHOLD: number = 20;

// MAXIMUM AMOUNT A FLOATER CAN BE ADDED
export const FLOATER_AMOUNT_MAXIMUM: number = 15000;

// MINIMUM AMOUNT A FLOATER CAN BE ADDED
export const FLOATER_AMOUNT_MINIMUM: number = 1000;

// Maximum age homeowners and condo property can be as determined by carrier
export const HOME_MAX_AGE: Map<Carrier, number> = new Map([
  [Carrier.Economical, 80],
  [Carrier.Intact, 100],
  [Carrier.Promutuel, 100],
  [Carrier.Travelers, 100],
  [Carrier.Unique, 150],
  [Carrier.Wawanesa, 100],
]);

export const MAX_DWELLING_AGE_WARNING_THRESHOLD: number = 45;

export const MAX_NUMBER_OF_MORTGAGES = 2;

// Number of years panel type must be asked
export const PANEL_TYPE_THRESHOLD = 25;

// Acceptable amperage values
export const AMPERAGE_VALUES: number[] = [60, 100, 200];

// Maximum accepted claims number
export const HOME_CLAIMS_MAXIMUM: number = 3;

/** We are only interested in claims going back this number of years. */
export const HOME_CLAIMS_MAX_AGE_YEARS = 8;

// Home older than 40 years require more screening questions
export const HOME_AGE_SCREENING_THRESHOLD = 40;

// Minimum house construction year.
export const MIN_CONSTRUCTION_YEAR = 1820;

// List of unacceptable additional heating types for each home line
export const UNACCEPTABLE_ADDITIONAL_HEATING: Record<HomeLine, AdditionalHeating[]> = {
  homeowner: [
    AdditionalHeating.Other,
    AdditionalHeating.GasFireplace,
    AdditionalHeating.Oil,
    AdditionalHeating.OilFireplace,
    AdditionalHeating.WoodBurningStove,
    AdditionalHeating.WoodFireplace,
  ],
  condo: [AdditionalHeating.Other],
  tenant: [AdditionalHeating.Other],
};

// ========== Cars flow variable ==========

// Maximum of additional drivers
export const ADDITIONAL_DRIVERS_MAXIMUM: number = 2;

// Maximum accepted claims number
export const CAR_CLAIMS_MAXIMUM: number = 4;

/** We are only interested in claims going back this number of years. */
export const CAR_CLAIMS_MAX_AGE_YEARS = 6;

// Maximum accepted driving convictions number
export const DRIVING_CONVICTIONS_MAXIMUM: number = 4;

/** We are only interested in convictions going back this number of years. */
export const DRIVING_CONVICTIONS_MAX_AGE_YEARS = 5;

// Maximum accepted cars number
export const CARS_MAXIMUM: number = 3;

// Maximum of cars the garage can contains
export const GARAGE_CARS_MAXIMUM: number = 4;

// Number of days added to today used to compute the possession date threshold (can be negative, 0 is today, -1 is yesterday)
// Possession date before the resulting date will require an uninsured reason.
export const CAR_UNINSURED_REASON_POSSESSION_THRESHOLD = -1;

/** The applicant driver ID is constant. This should never be used directly, except for applicant driver facade and tests. */
export const __APPLICANT_DRIVER_ID = 'dri_fb7c115e24ea41998ca2d67ab00bfeab';

// ========== Common flow variables ==========
// Current default country
export const DEFAULT_COUNTRY: string = 'canada';

export const CARRIERS_NON_PAYMENT_REDIRECTION_HISTORY_YEARS: Partial<
  Record<Province, Partial<Record<Carrier, number>>>
> = {
  [Province.Ontario]: {
    [Carrier.Intact]: 25,
    [Carrier.Economical]: 10,
    [Carrier.Travelers]: 10,
  },
};

export const PRODUCT_MAX_ASSETS: Record<ProductType, number> = {
  [ProductType.Home]: 1,
  [ProductType.Car]: 3,
};

//===== Referral Program amount
// Used for strings where the referral amount is displayed
export const REFERRAL_PROGRAM_AMOUNT: string = '25';
